import { useContext } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { ProdutosMercosContext } from 'contexts/ProdutosMercosContext';
import { DropsContext } from 'contexts/DropsContext';
import { GridContext } from 'contexts/GridContext';
import { useModal } from 'components/Modals';
import ResumoModal from 'components/Modals/ResumoModal';
import Container from 'components/Container';
import Header from 'components/Header';
import Card from 'components/Card';
import Grid from 'components/Grid';
import Filter from './filter';

const Anúncios = () => {
  const rotina = 'ProdutoMercos';
  const titulo = 'Anúncios Integrados com Mercos';
  const navigate = useNavigate();
  const { openModal } = useModal();
  const { drops } = useContext(DropsContext);
  const { exportPdf, exportXls } = useContext(GridContext);
  const { produtosMercos, getProdutosMercos, getLoading } = useContext(
    ProdutosMercosContext
  );
  const { control, getValues, reset } = useForm({
    defaultValues: produtosMercos?.filter,
  });

  const loadGrid = (props) => {
    if (props?.replace) {
      reset();
    }
    getProdutosMercos({ ...props, rotina, filter: getValues() });
  };

  const options = [
    {
      name: 'Adicionar',
      icon: 'add',
      action: () => navigate('/app/Integrações/Mercos/Manutencao'),
    },
    {
      name: 'Exportar PDF',
      icon: 'file_download',
      action: () =>
        exportPdf({
          rotina,
          filter: getValues(),
          order: produtosMercos?.order,
        }),
    },
    {
      name: 'Exportar XLS',
      icon: 'file_download',
      action: () =>
        exportXls({
          rotina,
          filter: getValues(),
          order: produtosMercos?.order,
        }),
    },
    {
      name: 'Resumo',
      icon: 'summarize',
      action: () =>
        openModal(
          <ResumoModal
            colunas={produtosMercos?.colunas}
            onSubmit={(group) =>
              navigate('/app/Resumo', {
                state: { rotina, group, filter: getValues() },
              })
            }
          />
        ),
    },
    {
      name: 'Configurações',
      icon: 'settings',
      action: () => navigate('/app/Integrações/Mercos/Configuracoes'),
    },
  ];

  const rowOptions = [
    {
      name: 'Editar',
      icon: 'edit',
      action: ({ row }) =>
        navigate(`/app/Integrações/Mercos/Manutencao/${row?.id}`),
    },
    //     {
    //       name: 'Ativar',
    //       icon: 'key',
    //       show: ({ row }) => row?.status === 'paused',
    //       action: ({ row }) =>
    //         putProdutoMl({
    //           data: {
    //             id: row?.id,
    //             integra_access_id: row?.integra_access_id,
    //             status: 'active',
    //           },
    //           cb: loadGrid,
    //         }),
    //       menu: true,
    //     },
    //     {
    //       name: 'Inativar',
    //       icon: 'key_off',
    //       show: ({ row }) => row?.status === 'active',
    //       action: ({ row }) =>
    //         putProdutoMl({
    //           data: {
    //             id: row?.id,
    //             integra_access_id: row?.integra_access_id,
    //             status: 'paused',
    //           },
    //           cb: loadGrid,
    //         }),
    //       menu: true,
    //     },
  ];

  return (
    <Container>
      <Header
        rotina={rotina}
        titulo={titulo}
        colunas={produtosMercos?.colunas}
      />
      <Card>
        <Grid
          grid={produtosMercos}
          options={options}
          rowOptions={rowOptions}
          control={control}
          checkboxSelection
          loading={getLoading}
          loadGrid={loadGrid}
          activeFilter={(getActiveFilter) => getActiveFilter(getValues())}
          FilterComponent={
            <Filter grid={produtosMercos} control={control} drops={drops} />
          }
        />
      </Card>
    </Container>
  );
};

export default Anúncios;
